import { motion } from 'framer-motion';

// Reveals children with a cinematic horizontal "wipe" (clip-path) rather
// than a simple fade, for a curtain-opening feel on key media panels.
export const ClipReveal = ({ children, className = '', delay = 0, direction = 'left' }) => {
  const startClip = direction === 'left' ? 'inset(0 100% 0 0)' : 'inset(0 0% 0 100%)';
  return (
    <motion.div
      className={className}
      initial={{ clipPath: startClip }}
      whileInView={{ clipPath: 'inset(0 0% 0 0%)' }}
      viewport={{ once: true, margin: '-60px' }}
      transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  );
};
